import { PASSWORD_MIN_LENGTH } from '@lizrd/contracts';

/**
 * Live checklist mirroring the password policy in @lizrd/contracts. The server
 * remains the source of truth (the same rules are enforced there); this only
 * gives the user immediate feedback while typing.
 */
const CHECKS: { label: string; test: (v: string) => boolean }[] = [
  {
    label: `At least ${PASSWORD_MIN_LENGTH} characters`,
    test: (v) => v.length >= PASSWORD_MIN_LENGTH,
  },
  { label: 'An uppercase letter', test: (v) => /[A-Z]/.test(v) },
  { label: 'A lowercase letter', test: (v) => /[a-z]/.test(v) },
  { label: 'A number', test: (v) => /[0-9]/.test(v) },
  { label: 'A special character', test: (v) => /[^A-Za-z0-9]/.test(v) },
];

/** True when the value satisfies every rule — usable to gate submit buttons. */
export function isPasswordValid(value: string): boolean {
  return CHECKS.every(({ test }) => test(value));
}

export function PasswordRequirements({ value }: { value: string }) {
  return (
    <ul className="space-y-1 text-sm" aria-label="Password requirements">
      {CHECKS.map(({ label, test }) => {
        const ok = test(value);
        return (
          <li key={label} className={ok ? 'text-success' : 'text-muted'}>
            <span aria-hidden className="mr-1.5">
              {ok ? '✓' : '○'}
            </span>
            {label}
          </li>
        );
      })}
    </ul>
  );
}
